<script lang="ts">
    import type {RecordRow} from 'src/features/record-grid/lib/types';
    import {getSutorReportsOptimisationContext} from '../lib/sutor-reports-optimisation-context';
    import {get} from 'svelte/store';
    import {onDestroy} from 'svelte';
    import {exists} from 'shared/utils/custom-utils';
    import {getTextFromGridFieldValue} from 'src/features/sutor/sutor-utils';
    import KpBarebonesTableSelectableRow from 'shared/ui-widgets/table/barebones/KpBarebonesTableSelectableRow.svelte';
    import KpUserAvatar from 'shared/components/kp-user-avatar/KpUserAvatar.svelte';
    import KpChipTag from 'shared/ui-widgets/chip/KpChipTag.svelte';
    import KpBarebonesTableValue from 'shared/ui-widgets/table/barebones/KpBarebonesTableValue.svelte';
    import {SUTOR_REPORTS_APPROVING_SETTINGS, SUTOR_REPORTS_OPTIMISATION_SETTINGS} from 'src/features/sutor/sutor-constants';
    import {getFirstFieldByFieldTypeIdRecursive} from 'src/features/record-grid/lib/grid-fields';

    export let record: RecordRow;

    const dateField = getFirstFieldByFieldTypeIdRecursive(record, SUTOR_REPORTS_APPROVING_SETTINGS.dateFieldId);
    const workerField = getFirstFieldByFieldTypeIdRecursive(record, SUTOR_REPORTS_APPROVING_SETTINGS.workWorkerFieldId);
    const projectField = getFirstFieldByFieldTypeIdRecursive(record, SUTOR_REPORTS_OPTIMISATION_SETTINGS.projectFieldId);
    const forOptimisationField = getFirstFieldByFieldTypeIdRecursive(record, SUTOR_REPORTS_OPTIMISATION_SETTINGS.forOptimisationFieldId);

    const context = getSutorReportsOptimisationContext();
    let openedUser = get(context.openedUser);
    let usedForOptimisation = get(context.usedReportsForOptimisation);
    const openedUserUnsubscribe = context.openedUser.subscribe((currentOpenedUser) => openedUser = currentOpenedUser);
    const usedForOptimisationUnsubscribe = context.usedReportsForOptimisation.subscribe((currentUsedForOptimisation) => usedForOptimisation = currentUsedForOptimisation);

    $: isForOptimisation = exists(forOptimisationField) && typeof forOptimisationField === 'boolean' && forOptimisationField === true;

    onDestroy(() => {
        openedUserUnsubscribe();
        usedForOptimisationUnsubscribe();
    });
</script>

<KpBarebonesTableSelectableRow on:click={() => context.setOpenedUser(record)}
                               selected="{openedUser?.id === record.id}"
                               highlightStyle="{usedForOptimisation.includes(record.id) ? 'success' : null}">

    <td>
        <KpBarebonesTableValue field="{workerField}">
            <KpUserAvatar user="{null}"
                          sizePx="{18}"
                          userId="{workerField.recordReference.id}"
                          userName="{getTextFromGridFieldValue(workerField)}"/>

            {getTextFromGridFieldValue(workerField)}
        </KpBarebonesTableValue>
    </td>

    <td>
        <KpBarebonesTableValue field="{projectField}" fondId="{1}"/>
    </td>

    <td>
        <KpBarebonesTableValue field="{dateField}"/>
    </td>

    <td>
        <KpChipTag chipSize="xs" chipStyle="{isForOptimisation ? 'success-new' : 'danger-new'}">
            {isForOptimisation ? 'Ano' : 'Ne'}
        </KpChipTag>
    </td>
</KpBarebonesTableSelectableRow>